export default "__VITE_ASSET__pzB1D3aQ__"